import { useState, useEffect } from 'react';

export interface Friend {
  id: string;
  name: string;
  url: string;
  description: string;
  enabled: boolean;
}

export interface FriendsConfig {
  friends: Friend[];
}

export const useFriendsConfig = () => {
  const [friends, setFriends] = useState<Friend[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadFriends = async () => {
      try {
        // In development, carica dal file JSON
        if (import.meta.env.DEV) {
          const friendsConfig = await import('../config/friends.json');
          setFriends(friendsConfig.friends.filter(f => f.enabled));
        } else {
          // In production, potresti voler caricare da un endpoint API
          // Per ora usiamo lo stesso JSON
          const friendsConfig = await import('../config/friends.json');
          setFriends(friendsConfig.friends.filter(f => f.enabled));
        }
      } catch (err) {
        setError('Failed to load friends configuration');
        console.error('Error loading friends config:', err);
      } finally {
        setLoading(false);
      }
    };

    loadFriends();
  }, []);

  return { friends, loading, error };
};